import { render } from "./chefSettingsModel.vue?vue&type=template&id=334d332c"
import script from "./chefSettingsModel.vue?vue&type=script&lang=js"
export * from "./chefSettingsModel.vue?vue&type=script&lang=js"

import "./chefSettingsModel.vue?vue&type=style&index=0&id=334d332c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__